import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import { IOffer } from "../../offers.types";

export const requestGetOffers = async (
  params: GetListRequestParams
): Promise<GetListResponse<IOffer>> => {
  return await instance.get(ApiRoutesOffers.SpecialOffers, {
    params
  });
};
